const data = [
    {
        id: 1,
        title: "Gomi Gata",
        tools: ["ejs", "css3", "js", "java", "nodejs", "express", "mongodb"],
        demoUrl: "https://gomiapi-production.up.railway.app/",
        description: "If you've ever been confused about where and how exactly you're supposed to get rid of your disposable items then Gomi Gata is for you. This simple app lets you search for common household items and will generate information for disposal. This app was created for and by Japan ex-pats.",
        contributors: ['meghann', 'sylvio', 'sulamayne', 'suheily', 'louis'],
        imageUrl: "https://res.cloudinary.com/dc1aiqs4p/image/upload/v1667412594/Screen_Shot_2022-11-02_at_12.16.13_gpzos7.png",
        repoUrl: "https://github.com/meghannfh/GomiAPI"
    },
    {
        id: 2,
        title: "Sketchr",
        tools: ["ejs", "css3", "js", "nodejs", "express", "mongodb"],
        demoUrl: "https://sketchr-production.up.railway.app/",
        description: "Track and share your illustrative progress with Sketchr! Sketchr serves as your personal online sketchbook and will let you know how many days in a row each month you are able to contribute. Art-block? Grab a prompt from our prompt generator to give you some inspiration for your work.",
        contributors: ['meghann'],
        imageUrl: "https://res.cloudinary.com/dc1aiqs4p/image/upload/v1667412602/Screen_Shot_2022-11-02_at_12.15.53_gxalsd.png",
        repoUrl: "https://github.com/meghannfh/sketchr"
    },
    {
        id: 3,
        title: "Encyclopedia of Hyrule",
        tools: ["html", "css3", "js"],
        demoUrl: "https://botw-encyclopedia.netlify.app/",
        description: "Hey! Listen! Are you a Zelda fan? Well, now there's an interface that'll let you search through a comprehensive encyclopedia of Hyrule's creatures, monsters, treasure, etc.",
        contributors: ['minh', 'meghann'],
        imageUrl: "https://res.cloudinary.com/dc1aiqs4p/image/upload/v1667412587/Screen_Shot_2022-11-02_at_12.17.31_kny0yn.png",
        repoUrl: "https://github.com/meghannfh/breathOfTheWIldAPI"
    }
]

export default data